import PropTypes from 'prop-types'
import React from 'react'

import Link from '../../templateComponents/Link'
import Plugin from '../../templateComponents/Plugin'

export default function Category({ category, productData }) {
  return (
    <div className="template-category">
      <h1>{category.title}</h1>
      <Plugin type="epages.text" _id="category" />
      <div>
        {productData.products.map((product) => (
          <div key={product.productId}>
            <div className="product-link">
              <Link to={product.href}>{product.name}</Link>
            </div>
            {product.price && <div>{product.price.formatted}</div>}
            {product.basePrice && <div>{product.basePrice.formatted}</div>}
            {product.image && (
              <div>
                <img src={product.image.url} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

Category.propTypes = { category: PropTypes.object.isRequired, productData: PropTypes.object.isRequired }
